import React,  { Component } from 'react';
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import {withStyles} from '@material-ui/core/styles';
import {BoxDrag} from './BoxDrag'
import {Dustbin} from './Dustbin'

const useStyles = (theme) => ({
  root: {
    display: 'flex',
    marginBottom: '1rem',
    marginTop: '1rem',
  },
  panel:{
    maxHeight: 380,
    overflow: 'auto',    
  }
})

class ChartTypeLine extends Component {

  constructor(props){
    super(props)    
    this.state = {
      isLoaded:false,
      options: {},
      managerOptions: [        
        {
          allowedDropEffect: "any",
          title: "Séries", 
          identify: "series",       
          data:[],        
        }
        
    
      ],      
    }         
  }
 
  componentDidUpdate(prevProps, prevState){    
    // if(!Object.is(prevProps.config.option, prevState.options)){
    if(!prevState.isLoaded){
      this.loadingAll()      
    }

    
  }

  loadingAll = () => {      
    if(!this.props.config.option) return    
    let newOption = this.props.config.option
    Object.assign(newOption, this.props.config.option)  
    
      if(!newOption.series)
        newOption.series = []    
    
      newOption.series.map(serie=>            
      serie.data = this.props.dataset.map(o=>o[serie.name]),
    )    

    let newMp = [...this.state.managerOptions]
    newMp[0].data = []
    newOption.series.forEach(serie => {
      serie.color?(
        newMp[0].data.push({
          name: serie.name,
          color: serie.color,
        }) 
      ):(
        newMp[0].data.push({
          name: serie.name,          
        }) 
      )
    })


    this.setState({
      isLoaded: true,
      managerOptions: newMp,
      options: newOption,       
    })    
  }

  getPropertiesName = (data) => {          
    return this.props.dataset && this.props.dataset.length > 0
      ?Object.getOwnPropertyNames(this.props.dataset[0]).sort():[]         
  }

  handleSelected = (item, dropResult) => {        
    let newMp = [...this.state.managerOptions]
    const indexMp = newMp.map(m=>m.identify).indexOf(dropResult.name);
    //se já existe no array, não irá adicionar
    if(newMp[indexMp].data.find((d)=>d.name === item.name)){
      return
    }
    newMp[indexMp].data.push({
      name: item.name,
      color: '',
    }) 
    this.setState({managerOptions: newMp})
    this.managerOption()
  }

  eventOnDelete = (name, item,  identify) => {         
    // this.props.eventOnDelete
    let newMp = [...this.state.managerOptions]
    const indexMp = newMp.map(m=>m.identify).indexOf(identify)
    // const indexData = newMp[indexMp].data.map(d=>d.name).indexOf(name)
    const newData = newMp[indexMp].data.filter(i => i.name !== name)
    newMp[indexMp].data = newData
    this.setState({managerOptions: newMp})
    this.managerOption()
  }
  
  eventOnColor = (e, b, item, identify) => {     
    // this.props.eventOnColor    
    let newMp = [...this.state.managerOptions]
    const indexMp = newMp.map(m=>m.identify).indexOf(identify)
    const indexData = newMp[indexMp].data.map(d=>d.name).indexOf(item.name)
    // let d = newMp[indexMp].data[indexData];
    newMp[indexMp].data[indexData] = {
      name: item.name,
      color: e.hex,
    }
    this.setState({managerOptions: newMp})
    this.managerOption()
  }

  managerOption = () => {
    // this.state.managerOptions    
    const mpSeries = this.state.managerOptions[0]
    let dataOption = []

    mpSeries.data.map( d => 
      d.color?(dataOption.push({
          name: d.name,        
          color:d.color,
          data: this.props.dataset.map(o=>o[d.name]),
        })     
      ):(dataOption.push({
        name: d.name,        
        data: this.props.dataset.map(o=>o[d.name]),
      })      
      ) 
    )

    let opt = {
      title: {
        text: ''
      },  
      legend: {
          layout: 'vertical',
          align: 'right',
          verticalAlign: 'middle'
      },  
      plotOptions: {
          series: {
              label: {
                  connectorAllowed: false
              },
              pointStart: 1
          }
      },
      series: dataOption,  
      responsive: {
          rules: [{
              chartOptions: {
                  legend: {
                      layout: 'horizontal',
                      align: 'center',
                      verticalAlign: 'bottom'
                  }
              }
          }]
      }
  
    }

    this.setState({options: opt})
    this.props.onEventOption(opt)
  }
  
  render(){

    const { classes} = this.props;

    return(
      <div>
        <div className={classes.root}>
    
            
            <div className={classes.panel} >                   
              {this.getPropertiesName().map((item) =>               
                <BoxDrag key={item} name={item} eventOnChange={this.handleSelected} />
              )}          
            </div>      

            {this.state.managerOptions.map((item, index)=> 
              <div key={index} >             
                <Dustbin   
                    key={index}                
                    allowedDropEffect={item.allowedDropEffect} 
                    title={item.title} 
                    identify={item.identify}                  
                    data={item.data}     
                    eventOnDelete={this.eventOnDelete}             
                    eventOnColor={this.eventOnColor}             
                  />
              </div>)}
                                
        </div>  

           
        <HighchartsReact          
          highcharts={Highcharts}          
          options={this.state.options}
        />
      </div>
    )
  }

}

export default withStyles(useStyles)(ChartTypeLine)